import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { BsArrowsExpand, BsArrowsCollapse } from 'react-icons/bs';
import { Button } from 'react-bootstrap';

import { editElementsCollapseState } from '@editor2/reducers/editor/editorSlice';
import { CollapseState } from '@editor2/types/collapseState';
import { toolsBlock } from '@editor2/containers/PageElementsPage/styles';

interface Props {
	courseId: number;
}

const Tools: FC<Props> = (props) => {
	const { courseId } = props;

	const dispatch = useDispatch();

	const onChange = (value) => {
		dispatch(editElementsCollapseState({ ...value, courseId }));
	};

	return (
		<div className={toolsBlock}>
			<Button
				variant="outline-secondary"
				onClick={() => onChange({ collapseState: CollapseState.ExpandAllQuestions })}>
				<BsArrowsExpand />
				Expand All Questions
			</Button>
			<Button
				variant="outline-secondary"
				onClick={() => onChange({ collapseState: CollapseState.RevealAllHTML })}>
				<BsArrowsExpand />
				Reveal All HTML
			</Button>

			<Button
				variant="outline-secondary"
				onClick={() => onChange({ collapseState: CollapseState.ExpandAll })}>
				<BsArrowsExpand />
				Expand All
			</Button>
			<Button
				variant="outline-secondary"
				onClick={() => onChange({ collapseState: CollapseState.CollapseAll })}>
				<BsArrowsCollapse />
				Collapse All
			</Button>
		</div>
	);
};

export default Tools;
